import { Route } from '@angular/router';
import { AppUrls } from '../../../../../../common/dto/app-urls';
import { KnowledgeBaseEditorRoutes } from './knowledge-base-editor/knowledge-base-editor.routes';

export const KnowledgeBaseRoute: Route = {
  path: AppUrls.Dashboard._.Help._.KnowledgeBase.relativeUrl,
  children: [
    {
      path: AppUrls.Dashboard._.Help._.KnowledgeBase._.ArticleList.relativeUrl,
      loadComponent: () => import('./article-list/article-list.component').then(_ => _.ArticleListComponent),
      pathMatch: 'full',
    },
    {
      path: AppUrls.Dashboard._.Help._.KnowledgeBase._.ArticleEditor.relativeUrl,
      loadComponent: () => import('./article-editor/article-editor.component').then(_ => _.ArticleEditorComponent),
    },
    {
      path: AppUrls.Dashboard._.Help._.KnowledgeBase._.KnowledgeBaseList.relativeUrl,
      loadComponent: () => import('./knowledge-base-list/knowledge-base-list.component').then(_ => _.KnowledgeBaseListComponent),
      pathMatch: 'full',
    },
    KnowledgeBaseEditorRoutes,
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Help._.KnowledgeBase._.ArticleList.relativeUrl,
    },
  ],
};
